import { Component, Input } from "@angular/core";
import { CurrencyPipe, DatePipe } from "@angular/common";
import { TaskRequest, TaskType } from "@models/task-request";
import { RequestStatusEnumPipe } from "../../../shared/pipes/request-status-enum.pipe";
import { TaskTypePipe } from "../../../shared/pipes/task-type.pipe";

@Component({
  selector: "app-task-info-card",
  imports: [CurrencyPipe, DatePipe, RequestStatusEnumPipe, TaskTypePipe],
  templateUrl: "./task-info-card.component.html",
  styleUrl: "./task-info-card.component.scss",
})
export class TaskInfoCardComponent {
  readonly TaskType = TaskType;

  @Input({ required: true }) task!: TaskRequest;
}
